/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Redact_Name_ValueInputs */

const da_forside_redact_name_value = /** @type {(inputs: Forside_Redact_Name_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anna Hansen`)
};

/** @type {(inputs: Forside_Redact_Name_ValueInputs) => LocalizedString} */
const en_forside_redact_name_value = da_forside_redact_name_value;

/**

* @param {Forside_Redact_Name_ValueInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_redact_name_value = /** @type {((inputs?: Forside_Redact_Name_ValueInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Redact_Name_ValueInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_redact_name_value(inputs)
	return /** @type {LocalizedString} */ ("Anna Hansen")
});